import React from 'react';
import PayBillsSuccessDF from '../components/SimulatorsComponents/DefualtSimulators/PayBillsSuccessDF';

//= ========================================================================
const Sim_D06_PayBillsSuccess = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <PayBillsSuccessDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_D06_PayBillsSuccess;
